module.exports = "<small *ngIf=\"errors\" class=\"text-danger\" translate>\n  <ul class=\"pl-4 mt-2\">\n    <li *ngFor=\"let error of errors\">{{ error }}</li>\n  </ul>\n</small>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/control-messages/control-messages.component.html
// module id = ./src/app/shared/control-messages/control-messages.component.html
// module chunks = main